<template>
  <vue-apex-charts
    class="donutComercial"
    type="donut"
    :series="series"
    :options="chartOptions"
    :height="height"
    :width="'300px'"
  />
</template>

<style lang="scss">
.donutComercial .apexcharts-tooltip {
  color: rgb(0, 0, 0);
  font-family: inherit;
  font-weight: 400;
}
</style>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DonutChartComercial',
  components: {
    VueApexCharts,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dados: {
      type: Object,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    height: {
      type: String,
      default: '182',
    },
  },
  data() {
    return {
      series: this.dados.valoresPorcentagem,
      chartOptions: {
        chart: {
          id: this.id,
          type: 'donut',
          height: this.height,
          width: '100%',
        },
        colors: this.dados.cores,
        dataLabels: {
          enabled: true,
          formatter(val) {
            return `${val.toFixed(2)}%`
          },
          style: {
            color: 'white',
            fontSize: '11px',
            fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
            fontWeight: 'bold',
          },
        },
        legend: {
          show: false,
        },
        labels: this.dados.nomes,
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                  fontWeight: 700,
                  color: '#6E6B7B',
                  formatter: () => 'Total',
                },
                value: {
                  show: true,
                  fontSize: '22px',
                  fontWeight: 700,
                  fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                  color: '#6E6B7B',
                  formatter: () => this.dados.quantidade[0] + this.dados.quantidade[1] + (this.dados.quantidade[2] ? this.dados.quantidade[2] : 0),
                },
                total: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: `${'Montserrat'}, Helvetica, Arial, serif`,
                  fontWeight: 700,
                  color: '#6E6B7B',
                  formatter: () => this.dados.quantidade[0] + this.dados.quantidade[1] + (this.dados.quantidade[2] ? this.dados.quantidade[2] : 0),
                },
              },
            },
          },
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val, v) => `${this.dados.quantidade[v.seriesIndex]}`,
          },
        },
      },
    }
  },
}
</script>
